<h4>Attachments</h4>
<app-bx-documents
    #attachments
    (deleteEvent)="uploadOrDelete()"
    (uploadEvent)="uploadOrDelete()"
    (fileCountEvent)="fileCountChanged($event)"
    [includeFolders]="false">
</app-bx-documents>
